import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/nominas/descuentos-empleados-adjuntos';
// /**
//  * GET Documentos Empleados
//  * @param {object} params
//  * @returns {Promise<object[]>}
//  */
// export const getDocumentosEmpleados = async () => {
//   try {
//     const response = await API.get(baseURI);
//     return response.data;
//   } catch (err) {
//     onError(err);
//   }
//   return [];
// };

/**
 * GET Documento Empleado
 * @param {object} params
 * @returns {Promise<object|null>}
 */
export const getDocumentosPercepcion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Documentos Empleados params
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDocumentosPercepciones = async (params) => {
  try {
    const response = await API.get(`${baseURI}`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Documento Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDocumentosPercepcion = (formData) => API.post('/nominas/descuentos-empleados-adjuntos/', formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
/**
 * PATCH Documento Empleado
 * @param {number} id
 * @param {FormData} formData
 * @returns {Promise<object|boolean>}
 */
export const patchDocumentosPercepcion = async (id, formData) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Documento Empleado
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteDocumentosPercepcion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Documentos Empleado Status
 * @param {object} values
 * @returns {Promise<{}>}
 */
export const putDocumentosPercepcionStatus = async (values) => {
  try {
    const response = await API.put('catalogos/actualizar-documentos-empleado-status', values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
